import { webApi } from '@lib/api'

export const listCountry = () => webApi({ auth: true }).get('/v1/countries')
